// extracted by mini-css-extract-plugin
export default {"wrap":"DishesPage_wrap__akIOz","menuBlock":"DishesPage_menuBlock__8I08Q","outletBlock":"DishesPage_outletBlock__Tus3V"};